//请自行添加语言资源
const item = {
  projectCode: '项目代码',
  projectName: '项目名称',
  shipperCode: '货主代码',
  shipperName: '货主',
  costCode: '成本中心代码',
  costName: '成本中心',
  companyCode: '所属机构编号',
  companyName: '所属机构',
  acitveOff: '是否启用',
  createTime: '创建时间',
  creator: '创建者',
  updateTime: '修改时间',
  updater: '修改者',
  msg: {
    projectCode: '请输入项目代码',
    projectName: '请输入项目名称',
    shipperCode: '请选择所属货主',
    companyCode: '请选择所属机构',
    costCode: '请输入成本中心代码',
    costName: '请输入成本中心名称',
    acitveOff: '是否启用'
  }
};
export default item



// WEBPACK FOOTER //
// ./src/page/mdm/item/lang/item.zh.js